import React, {Fragment} from "react"

const BlogAuthor = (props) => {
    return (
        <Fragment>
            <figure className={`author-blockquote mb-30 ${props.bgColor}`}>
                <figcaption className="blockquote-footer">
                    Jason Momoa
                </figcaption>
                <blockquote className="blockquote">
                    <p>" Visualizar dramáticamente el liderazgo interactivo a través del ROI funcionalizado.
                        Simplificar profesionalmente iniciativas sinérgicas antes de canales efectivos. Crear
                        dramáticamente innovación completamente investigada con alianzas multifuncionales."</p>
                </blockquote>
            </figure>
        </Fragment>
    )
}

export default BlogAuthor